import * as React from 'react';

const events = window.PointerEvent ? ['pointerdown'] : ['mousedown', 'touchstart'];

export type UseClickOutsideConfig = {
  ignoreClass?: string
};

export const useClickOutside = (
  elementRef: React.RefObject<HTMLElement>,
  onClickOutside: (event: MouseEvent | TouchEvent | PointerEvent) => any,
  config?: UseClickOutsideConfig
) => {
  const ignoreClass = config?.ignoreClass;
  React.useEffect(() => {
    const onClickDocument = (event: MouseEvent | TouchEvent | PointerEvent) => {
      const { target } = event;
      if (!(target instanceof HTMLElement) && !(target instanceof SVGElement)) return;
      const element = elementRef.current;
      if (!element) return;

      let el = target;
      do {
        if (ignoreClass && el.classList.contains(ignoreClass)) return;
        if (el === element) return;
        el = el.parentElement;
      } while (el);
      onClickOutside(event);
    }
    events.forEach((eventName) => document.addEventListener(eventName, onClickDocument, { passive: true }));
    return () => {
      events.forEach((eventName) => document.removeEventListener(eventName, onClickDocument));
    }
  }, [elementRef, onClickOutside, ignoreClass]);
}